import React, {useState} from 'react'
import './styles.scss'

import services from '../../../../services';
import { useHistory, } from "react-router-dom";
import ArrowForward from '@material-ui/icons/ArrowForward'

import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined'


const MenuAlt = (props) => {

  
    const history = useHistory();

    const [openMenu, setOpenMenu] = useState(false);
    const changeMenu = () => {
      setOpenMenu(!openMenu);
    }

    const sair = () => {
      services.storage.clear()
      history.push(`/`)
    }

    return (
      <div className="menuAltWrapper" onClick={changeMenu}>
        <AccountCircleOutlined/>
        <ul className={`${props.showMobile ? 'show' : ''} showOnlyDesktop`}>
          <li className="readOnly">
            <span> Olá, {props.nome?.split(' ')[0]} </span>
          </li>
        </ul>
        <div className={ openMenu ? "menuAltButtons" : "close"} >
          <a href="/meu-cadastro">
            Meus dados
            <ArrowForward htmlColor="#5CCBE1" className="menuArrow"/>
          </a>
          <button onClick={sair}>
            Sair
            <ArrowForward htmlColor="#5CCBE1" className="menuArrow"/>
          </button>
        </div>
      </div>
    )
  }

export default MenuAlt